import React, { useEffect, useState } from "react";
import ListLayout from "../../../../../partials/content/ListLayout";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import CustomerBasicInfo from "./customerBasicInfo";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import CustomerForm from "../customerForm";
import CustomerAddresses from "./customerAddresses";
import CustomerContacts from "./customerContacts";
import CustomerInvoices from "./customerInvoices";
import CustomerPayments from "./customerPayments";
import CustomerQuotations from "./customerQuotations";
import CustomerSalesOrders from "./customerSalesOrders";
import CustomerPendingGIs from "./CustomerPendingGIs";
import Notes from "../../../common/notes";
import Attachments from "../../../common/attachments";
import { getCustomer } from "../../../../../services/sales/customerService";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function CustomerDetail({ history, match }) {
  const { reload } = useGlobalData();
  const [auth, setAuth] = useState({});
  const [component, setComponent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("Basic Info");
  const [open, setOpen] = useState(false);
  const listMenu = [
    {
      key: "basicInfo",
      label: "Basic Info",
      icon: "fas fa-th-large",
    },
    {
      key: "addresses",
      label: "Addresses",
      icon: "fas fa-map-marked-alt",
    },
    {
      key: "contacts",
      label: "Contacts",
      icon: "fas fa-address-card",
    },
    {
      key: "quotations",
      label: "Quotations",
      icon: "fas fa-file-contract",
    },
    {
      key: "salesOrders",
      label: "Sales Orders",
      icon: "fas fa-tags",
    },
    {
      key: "invoices",
      label: "A/R Invoices",
      icon: "fas fa-file-invoice-dollar",
    },
    {
      key: "payments",
      label: "A/R Payments",
      icon: "fas fa-credit-card",
    },
    {
      key: "pendingGIs",
      label: "Pending GIs",
      icon: "fas fa-shipping-fast",
    },
    {
      key: "attachments",
      label: "Attachments",
      icon: "fas fa-paperclip",
    },
    {
      key: "notes",
      label: "Notes",
      icon: "fas fa-sticky-note",
    },
  ];
  const defaultSelected = "basicInfo";
  const [customer, setCustomer] = useState({});

  async function getCustomerData() {
    const customerID = match.params.customerID;
    const response = await getCustomer(customerID);
    const { data, auth } = response.data;
    const { customer } = data;
    setComponent(<CustomerBasicInfo customer={customer} />);
    setAuth(auth);
    setCustomer(customer);
  }
  const customerID = match.params.customerID;

  const actionButtons = [];
  actionButtons.push({
    title: "",
    color: "label-brand",
    icon: "fas fa-backward",
    onClick: () => {
      history.push("/sales/customers");
    },
  });
  actionButtons.push({
    title: "Edit Customer",
    color: "primary",
    icon: "fas fa-edit",
    onClick: () => {
      setCustomer(customer);
      setOpen(true);
    },
  });
  useEffect(() => {
    getCustomerData();
  }, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle ? headerTitle : "Basic Info"}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/customers",
            title: "Customers",
            active: false,
          },
          {
            page: "/sales/customer-detail" + customerID,
            title: "Customer ID " + customerID + " " + customer.customerName,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        <ListLayout
          component={component}
          listMenu={listMenu}
          onSelectItem={(key) => {
            handleSelectItem(key);
          }}
          defaultSelected={defaultSelected}
        />
      </ContentLayout>
      <DialogLayout
        open={open}
        title="Customer Form"
        onCloseDialog={() => {
          setOpen(false);
        }}
        maxWIdth="md"
      >
        <CustomerForm
          customer={customer}
          onCloseDialog={() => {
            setOpen(false);
          }}
          onReloadCustomers={() => {
            getCustomerData();
            setOpen(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function handleSelectItem(key) {
    let componentTmp;
    let headerTitleTmp;
    switch (key) {
      case "basicInfo":
        componentTmp = <CustomerBasicInfo customer={customer} />;
        headerTitleTmp = "Basic Info";
        break;
      case "addresses":
        componentTmp = (
          <CustomerAddresses
            customerID={customer.ID}
            editAuth={customer.edit}
          />
        );
        headerTitleTmp = "Addresses";
        break;
      case "contacts":
        componentTmp = (
          <CustomerContacts customerID={customer.ID} editAuth={customer.edit} />
        );
        headerTitleTmp = "Contacts";
        break;
      case "quotations":
        componentTmp = (
          <CustomerQuotations customerID={customer.ID} history={history} />
        );
        headerTitleTmp = "Quotations";
        break;
      case "salesOrders":
        componentTmp = (
          <CustomerSalesOrders customerID={customer.ID} history={history} />
        );
        headerTitleTmp = "Sales Orders";
        break;
      case "invoices":
        componentTmp = (
          <CustomerInvoices customerID={customer.ID} history={history} />
        );
        headerTitleTmp = "A/R Invoices";
        break;
      case "payments":
        componentTmp = (
          <CustomerPayments customerID={customer.ID} history={history} />
        );
        headerTitleTmp = "A/R Payments";
        break;
      case "pendingGIs":
        componentTmp = (
          <CustomerPendingGIs customerID={customer.ID} history={history} />
        );
        headerTitleTmp = "Pending GIs";
        break;
      case "attachments":
        componentTmp = <Attachments docType="CUST" docID={customer.ID} />;
        headerTitleTmp = "Attachments";
        break;
      case "notes":
        componentTmp = <Notes docType="CUST" docID={customer.ID} />;
        headerTitleTmp = "Notes";
        break;
      default:
        componentTmp = <CustomerBasicInfo customer={customer} />;
        headerTitleTmp = "Basic Info";
        break;
    }
    setComponent(componentTmp);
    setHeaderTitle(headerTitleTmp);
  }
}

export default CustomerDetail;
